import { getMessages } from '../../../../../../../../store/constants';
import { EBoardSetting } from './types';

export const BOARD_SETTINGS_EMPTY_TITLE = getMessages().getText('board_settings.empty.title');
export const BOARD_SETTINGS_EMPTY_TEXT = getMessages().getText('board_settings.empty.text');

export const BOARD_DETAILS_SELECTOR_MAP: {[key: string]: string} = {
    // notifications
    [EBoardSetting.EMAIL_NOTIFICATIONS]: 'email-notifications',
    [EBoardSetting.APP_NOTIFICATIONS]: 'notifications',

    // card
    [EBoardSetting.CARD_PREFIXES]: 'prefixes',
    [EBoardSetting.CARD_PROPERTIES]: 'card-properties',
    [EBoardSetting.CUSTOM_PROPERTIES]: 'card-custom-properties',
    [EBoardSetting.CARD_AGING]: 'card-aging',
    [EBoardSetting.COLOR_LABELS]: 'colors',
    [EBoardSetting.TAGS]: 'tags',
    [EBoardSetting.ROLES]: 'roles',
    [EBoardSetting.GANTT]: 'gantt',
    [EBoardSetting.ARCHIVE_UPON_DELETION]: 'archive-on-del',
    [EBoardSetting.LINKS_PREVIEW]: 'open-graph',
    [EBoardSetting.STATUS_MAPPING]: 'statuslists',
    [EBoardSetting.WEBHOOKS]: 'webhooks',

    // other
    [EBoardSetting.DATES_TIME]: 'time',
    [EBoardSetting.ESTIMATE]: 'estimate-time',
    [EBoardSetting.TIME_ZONE]: 'timezone',
    [EBoardSetting.BOARD_EMAIL]: 'email',
    [EBoardSetting.MOVE_TO]: 'move-to',
    [EBoardSetting.IMPORT_PWC]: 'pwc-import',
    [EBoardSetting.IMPORT]: 'board-import',
    [EBoardSetting.COPY]: 'copy',
    [EBoardSetting.TEMPLATE]: 'template',
}
